import styled from "styled-components";
import { defaultTheme } from "../../shared/constants";

export type CheckboxProps = {
  name: string;
  value: string;
  checked?: boolean;
  disabled?: boolean;
  onChange?: (event: React.ChangeEvent<HTMLInputElement>) => void;
  label: string;
};

export const Checkbox = ({
  name,
  value,
  checked,
  onChange,
  disabled,
  label,
}: CheckboxProps) => {
  return (
    <CheckboxContainer>
      <CheckboxInput
        id={name}
        type="checkbox"
        name={name}
        value={value}
        checked={checked}
        disabled={disabled}
        onChange={onChange}
      />
      <label htmlFor={name}>{label}</label>
    </CheckboxContainer>
  );
};

const CheckboxContainer = styled.div`
  display: flex;
  align-items: center;
`;

const CheckboxInput = styled.input`
  appearance: none;

  width: 18px;
  height: 18px;

  border: 2px solid ${defaultTheme.COLORS.BLUE_DARK};
  border-radius: 2px;
  transition: 0.2s all linear;
  margin-right: 5px;
  position: relative;
  cursor: pointer;

  &:checked {
    border-color: ${defaultTheme.COLORS.WHITE};
    background-color: ${defaultTheme.COLORS.WHITE};
  }

  &:disabled {
    opacity: 0.4;
    cursor: default;
  }

  &:checked::after {
    content: "";
    display: block;
    width: 18px;
    height: 18px;
    background-color: ${defaultTheme.COLORS.BLUE_DARK};
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    clip-path: path(
      "M2.3 17.5C1.8 17.5 1.375 17.325 1.025 16.975C0.675 16.625 0.5 16.2 0.5 15.7V2.3C0.5 1.8 0.675 1.375 1.025 1.025C1.375 0.675 1.8 0.5 2.3 0.5H15.7C16.2 0.5 16.625 0.675 16.975 1.025C17.325 1.375 17.5 1.8 17.5 2.3V15.7C17.5 16.2 17.325 16.625 16.975 16.975C16.625 17.325 16.2 17.5 15.7 17.5H2.3ZM7.6 12.85L14.325 6.125L13.275 5.075L7.6 10.75L4.75 7.9L3.7 8.95L7.6 12.85Z"
    );
  }
`;
